















import { BAlert } from 'bootstrap-vue';
import { get } from 'lodash';
import { PeriodOptions } from './utils';
import { getCustomRepeatMessage, getQuickSuggestionsMessage } from './suggestions';

export default {
  name: 'ScheduleMessage',
  components: {
    BAlert,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    message() {
      let repeat = get(this.form, 'repeatOption.value', PeriodOptions.DoesNotRepeat);
      if (repeat === PeriodOptions.DoesNotRepeat) {
        return;
      }

      let message;
      if (repeat === PeriodOptions.Custom) {
        message = getCustomRepeatMessage(this.form);
      } else {
        message = getQuickSuggestionsMessage(this.form);
      }

      return message;
    },
  },
};
